import DigitalAssetsOfferingProfilePageContainer from 'apex-web/lib/components/DigitalAssets/DigitalAssetsOfferingProfilePageContainer';
import { connect } from 'react-redux';
import { digitalAssetSelector } from 'apex-web/lib/redux/selectors/digitalAssetsSelectors';
import get from 'lodash/get';
import './DigitalAssetsOfferingProfilePage.css';

const DigitalAssetsOfferingProfilePage = ({ digitalAsset }) => {
  const onViewMoreClick = () => {
    window.open(digitalAsset.MarketingUrl, '_blank', 'noreferrer');
  };
  return (
    <div className="digital-assets-offering-profile-page">
      <div className="digital-assets-offering-profile-page__gradient">
        {digitalAsset.MarketingUrl && (
          <div
            className="offering-profile__header-view-more"
            onClick={onViewMoreClick}>
            View More
          </div>
        )}
      </div>
      <DigitalAssetsOfferingProfilePageContainer />
    </div>
  );
};

const mapStateToProps = (state, ownProps) => ({
  digitalAsset: digitalAssetSelector(state, {
    ProductId: parseInt(get(ownProps, 'match.params.id', 0))
  })
});

export default connect(mapStateToProps)(DigitalAssetsOfferingProfilePage);
